import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M2 12l10 7.422l10 -7.422","key":"svg-0"}],["path",{"d":"M7 9l5 4l5 -4","key":"svg-1"}],["path",{"d":"M11 6l1 .8l1 -.8l-1 -.8l-1 .8","key":"svg-2"}]]

const IconBrandJuejin = createReactComponent('outline', 'brand-juejin', 'BrandJuejin', __iconNode);

export default IconBrandJuejin;